export default __webpack_public_path__ + "static/media/guide0202_m.d48e5878.jpg";